import { VirtualSiteGroupDtoToEntity } from "src/app/features/VirtualSiteGroup/services/mappers/VirtualSiteGroupDtoToEntity";
import type { VirtualSiteGroupDto } from "src/app/features/VirtualSiteGroup/types/VirtualSiteGroupDto";
import type { VirtualSiteGroupEntity } from "src/app/features/VirtualSiteGroup/types/VirtualSiteGroupEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const VirtualSiteGroupTableDtoMapper = (
    input: Readonly<ResourcePageDto<VirtualSiteGroupDto>>,
): ResourcePageEntity<VirtualSiteGroupEntity> => {
    return {
        list: input.list ? input.list.map(VirtualSiteGroupDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
